'use client';

import { FC, useState } from 'react';
import ILink from '~/data/strapi/types/shared-components/link';

import BurgerMainLinks from './links';
import styles from './styles.module.css';
import BurgerSublinks from './sublinks';

interface Props {
  links: ILink[];
}

const BurgerNavigation: FC<Props> = ({ links }) => {
  const [openedLink, setOpenedLink] = useState<ILink | null>(null);

  const parentHref = openedLink ? openedLink.href : null;

  return (
    <nav className={styles.nav}>
      {!openedLink && <BurgerMainLinks links={links} onClick={(link) => setOpenedLink(link)} />}

      {openedLink && openedLink.links && (
        <BurgerSublinks
          parentHref={parentHref}
          link={openedLink}
          sublinks={openedLink.links}
          onClose={() => setOpenedLink(null)}
        />
      )}
    </nav>
  );
};

export default BurgerNavigation;
